import useProductTypeLabels from "../../../hooks/useProductTypeLabels"

const useCollectionBuyersGuide = product => {
  const productTypeLabels = useProductTypeLabels()

  const filteredCollections = product?.collections?.filter?.(collection => {
    return !productTypeLabels.includes(collection.title)
  })
  return filteredCollections?.[0]?.wpCollection?.buyersGuide?.text
}

export default useCollectionBuyersGuide
